import { useEffect, useState } from "react";
import { getFeatures } from "~/services/antecipebackoffice/features";

// Chaves de /features: camelCase da flag do BE sem `_ENABLED` (FEEDBACK_CAPTURE_ENABLED → feedbackCapture).
const FLAG_KEYS = [
  "mergeManual",
  "mergeAutoArrival",
  "mergeAutoCompletion",
  "feedbackCapture",
  "packageExpiration",
  "slaDetector",
  "formOnlyConcluded",
  "dashboard",
  "continuousImprovement",
  "integrationsAdmin",
  "campaigns",
  "intelligence",
  "drillV2",
  "fundingPlanner",
  "financialPremises",
  "pricing",
  "seasonality",
  "preAntecipe",
  "growth",
  "churnModel",
  "growthActions",
  "drillV2",
  "growthDetectors",
  "registrationSeal",
  "slaRegistrationPause",
];

export const DISABLED_FEATURES = Object.freeze(
  Object.fromEntries(FLAG_KEYS.map((k) => [k, false])),
);

let cache = null;

export const loadFeatures = () => {
  if (!cache) {
    cache = getFeatures()
      .then((data) =>
        Object.fromEntries(FLAG_KEYS.map((k) => [k, data?.[k] === true])),
      )
      .catch(() => {
        cache = null;
        return DISABLED_FEATURES;
      });
  }
  return cache;
};

export const resetFeaturesCache = () => {
  cache = null;
};

export function useFeatures() {
  const [state, setState] = useState({
    loading: true,
    features: DISABLED_FEATURES,
  });
  useEffect(() => {
    let alive = true;
    loadFeatures().then((features) => {
      if (alive) setState({ loading: false, features });
    });
    return () => {
      alive = false;
    };
  }, []);
  return state;
}
